var SEPARATION = 100,
  AMOUNTX = 50,
  AMOUNTY = 50;
var container;
var camera, scene, renderer;
var particles,
  particle,
  count = 0;
var mouseX = 0;
var offsetY = 300;
var look;
var windowHalfX = document.body.clientWidth / 2;
var dotcolor = '#00B6BC';
var amplitude = 50;
var speed = 0.07;
var mousespeed = 0.02;
var spriteW = 512;
var PI2 = Math.PI * 2;
init();
animate();

function init() {
  container = document.createElement('div');
  document.getElementById('header-accueil').appendChild(container);
  camera = new THREE.PerspectiveCamera(
    75,
    window.innerWidth / window.innerHeight,
    1,
    10000
  );
  camera.position.z = 2000;
  camera.position.y = 100;
  camera.position.x = 50;

  var dotTexture = new THREE.Texture(generateTexture());
  // dotTexture.premultiplyAlpha = false;
  dotTexture.needsUpdate = true; // important!
  // dotTexture.anisotropy = 0;
  // dotTexture.magFilter = THREE.NearestFilter;

  scene = new THREE.Scene();
  look = new THREE.Vector3(
    scene.position.x,
    scene.position.y + 400,
    scene.position.z
  );
  particles = [];
  var material;
  if (webglAvailable()) {
    material = new THREE.SpriteMaterial({
      map: dotTexture,
      color: 0xffffff,
    });
  } else {
    material = new THREE.SpriteCanvasMaterial({
      color: dotcolor,
      program: function(context) {
        context.beginPath();
        context.arc(0, 0, 0.5, 0, PI2, true);
        context.fill();
      },
    });
  }

  var i = 0;
  for (var ix = 0; ix < AMOUNTX; ix += 1) {
    for (var iy = 0; iy < AMOUNTY; iy += 1) {
      particle = particles[(i += 1)] = new THREE.Sprite(material);
      particle.position.x = ix * SEPARATION - (AMOUNTX * SEPARATION) / 2;
      particle.position.z = iy * SEPARATION - (AMOUNTY * SEPARATION) / 2;
      scene.add(particle);
    }
  }
  // RENDERER
  if (webglAvailable()) {
    renderer = new THREE.WebGLRenderer({
      antialias: true,
      alpha: true,
    });
  } else {
    renderer = new THREE.CanvasRenderer({ alpha: true });
  }
  renderer.setClearColor(0x000000, 0.0);
  renderer.setPixelRatio(window.devicePixelRatio);
  renderer.setSize(document.body.clientWidth, window.innerHeight);
  container.appendChild(renderer.domElement);

  document.addEventListener('mousemove', onDocumentMouseMove, false);
  container.addEventListener('touchstart', onDocumentTouchStart, false);
  container.addEventListener('touchmove', onDocumentTouchMove, false);
  //
  window.addEventListener('resize', onWindowResize, false);
}

function generateTexture() {
  var canvas = document.createElement('canvas');
  canvas.width = canvas.height = spriteW;

  var context = canvas.getContext('2d');
  context.fillStyle = 'rgba(255,255,255,0.01)';
  context.fillRect(0, 0, canvas.width, canvas.height);
  context.beginPath();
  context.arc(spriteW / 2, spriteW / 2, spriteW / 2, 0, Math.PI * 2, false);
  context.lineWidth = 10;
  context.fillStyle = dotcolor;
  context.fill();

  return canvas;
}

function onWindowResize() {
  windowHalfX = document.body.clientWidth / 2;
  camera.aspect = document.body.clientWidth / window.innerHeight;
  camera.updateProjectionMatrix();
  renderer.setSize(document.body.clientWidth, window.innerHeight);
}
//
function onDocumentMouseMove(event) {
  mouseX = event.clientX - windowHalfX;
}

function onDocumentTouchStart(event) {
  if (event.touches.length === 1) {
    event.preventDefault();
    mouseX = event.touches[0].pageX - windowHalfX;
  }
}

function onDocumentTouchMove(event) {
  if (event.touches.length === 1) {
    event.preventDefault();
    mouseX = event.touches[0].pageX - windowHalfX;
  }
}
//
function animate() {
  requestAnimationFrame(animate);
  render();
}

function render() {
  camera.position.x += (mouseX - camera.position.x) * mousespeed;
  camera.lookAt(look);
  var i = 0;
  for (var ix = 0; ix < AMOUNTX; ix += 1) {
    for (var iy = 0; iy < AMOUNTY; iy += 1) {
      particle = particles[(i += 1)];
      particle.position.y =
        Math.sin((ix + count) * 0.3) * amplitude +
        Math.sin((iy + count) * 0.5) * amplitude -
        offsetY;
      particle.scale.x = particle.scale.y =
        (Math.sin((ix + count) * 0.3) + 1) * 4 +
        (Math.sin((iy + count) * 0.5) + 1) * 4;
    }
  }
  renderer.render(scene, camera);
  count += speed;
}

function webglAvailable() {
  try {
    var canvas = document.createElement('canvas');
    return (
      !!window.WebGLRenderingContext &&
      (canvas.getContext('webgl') || canvas.getContext('experimental-webgl'))
    );
  } catch (e) {
    return false;
  }
}
